module.exports = __webpack_public_path__ + "img/category2.5b1a1a49.jpg";